import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LayoutComponent } from './layout/layout.component';
import { roleGuard } from './core/guards/role.guard';
import { portalConfigResolver } from './core/resolvers/portal-config.resolver';
import { environment } from '../environments/environment';

const routeGuards = environment.auth.useLocalDevAuth ? undefined : [MsalGuard, roleGuard];

export const routes: Routes = [
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./features/access-denied/access-denied.component').then(m => m.AccessDeniedComponent),
  },
  {
    path: 'welcome',
    loadComponent: () =>
      import('./features/welcome/welcome.component').then(m => m.WelcomeComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: '',
    component: LayoutComponent,
    resolve: { portalConfig: portalConfigResolver },
    children: [
      {
        path: 'dashboard',
        data: { breadcrumb: 'Dashboard' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes),
      },
      {
        path: 'reports',
        data: { breadcrumb: 'Reports' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/reports/reports.routes').then(m => m.reportsRoutes),
      },
      {
        path: 'queues',
        data: { breadcrumb: 'Queues' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/queues/queues.routes').then(m => m.queuesRoutes),
      },
      {
        path: 'logs',
        data: { breadcrumb: 'Logs' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/logs/logs.routes').then(m => m.logsRoutes),
      },
      {
        path: 'documents',
        data: { breadcrumb: 'Document Search' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/documents/documents.routes').then(m => m.documentsRoutes),
      },
      {
        path: 'integrations',
        data: { breadcrumb: 'Integrations' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/integrations/integrations.routes').then(m => m.integrationsRoutes),
      },
      {
        path: 'webapi',
        data: { breadcrumb: 'WebAPI Invoices' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/webapi/webapi.routes').then(m => m.webapiRoutes),
      },
      {
        path: 'pi-orders',
        data: { breadcrumb: 'Pi Orders' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/pi-orders/pi-orders.routes').then(m => m.piOrdersRoutes),
      },
      {
        path: 'salesforce',
        data: { breadcrumb: 'Salesforce' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/salesforce/salesforce.routes').then(m => m.salesforceRoutes),
      },
      {
        path: 'oracle-fusion',
        data: { breadcrumb: 'Oracle Fusion' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/oracle-fusion/oracle-fusion.routes').then(m => m.oracleFusionRoutes),
      },
      {
        path: 'correlation-history',
        data: { breadcrumb: 'Correlation History' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/correlation-history/correlation-history.routes').then(
            m => m.correlationHistoryRoutes,
          ),
      },
      {
        path: 'as2',
        data: { breadcrumb: 'AS2' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/as2/as2.routes').then(m => m.as2Routes),
      },

      {
        path: 'sftp',
        data: { breadcrumb: 'SFTP' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/sftp/sftp.routes').then(m => m.sftpRoutes),
      },
      {
        path: 'email',
        data: { breadcrumb: 'Email' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/email/email.routes').then(m => m.emailRoutes),
      },
      {
        path: 'sftp-connectivity',
        data: { breadcrumb: 'SFTP Connectivity' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/sftp-connectivity/sftp-connectivity.routes').then(
            m => m.sftpConnectivityRoutes,
          ),
      },
      {
        path: 'external-alerts',
        data: { breadcrumb: 'External Alerts' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/external-alerts/external-alerts.routes').then(
            m => m.externalAlertsRoutes,
          ),
      },
      {
        path: 'oracle-fusion-lookup',
        data: { breadcrumb: 'Oracle Fusion Lookup' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/oracle-fusion-lookup/oracle-fusion-lookup.routes').then(
            m => m.oracleFusionLookupRoutes,
          ),
      },
      {
        path: 'xslt-tester',
        data: { breadcrumb: 'XSLT Tester' },
        canActivate: routeGuards,
        loadChildren: () =>
          import('./features/xslt-tester/xslt-tester.routes').then(m => m.xsltTesterRoutes),
      },
    ],
  },
];
